import { fetchProviderEstimateDetail } from "@/api/providerDashboard";

export default {
  async loadEstimate() {
    this.loading = true;
    try {
      const res = await fetchProviderEstimateDetail(this.$route.params.id);
      if (res.data.status === 200) {
        this.estimate = res.data.data;
        if (typeof this.initializeReplyForm === "function") {
          this.initializeReplyForm();
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.loading = false;
    }
  },
};
